function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M2 9v6c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3H5C3.34 6 2 7.34 2 9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.33 5.33v.34c0 .12 0 .23.01.35.05-.01.1-.02.16-.02h13c.06 0 .11.01.16.02.01-.11.01-.22.01-.35v-.34C18.67 2.67 18 2 15.33 2H8.67C6 2 5.33 2.67 5.33 5.33zM18.5 18h-13c-.06 0-.11-.01-.16-.02-.01.11-.01.22-.01.35v.34C5.33 21.33 6 22 8.67 22h6.66c2.67 0 3.34-.67 3.34-3.33v-.34c0-.12 0-.23-.01-.35-.05.01-.1.02-.16.02z"
})));